import React, { Fragment } from 'react';
import FamilyInformation from '../UI/FamilyInformation';

const FamilyInfoHeader = () => (
  <Fragment>
    <FamilyInformation />
  </Fragment>
);

export default FamilyInfoHeader;
